<div class="flex flex-col gap-4">
  @for (_ of [].constructor(cartons()); track $index) {
    <rid-egg-carton [changeable]="false" [eggs]="$last && eggs() % 10 != 0 ? eggs() % 10 : 10" [fillColor]="fillColor()" />
  }
</div>
